import {httpGet, httpPost, httpPut} from "./http";
import {getActiveAccount} from '../lib/activeMember';

const creditCardUrl = window.env.BACKEND_API_URL + '/cc';

const getCreditCards = async ({page = 1, perPage = 10}, signal) => {
    const accountID = getActiveAccount().id;
    const creditCardsUrl = `${creditCardUrl}?account_id=${accountID}&page=${page}&per_page=${perPage}`;

    return await httpGet(creditCardsUrl, signal);
};

const storeCreditCard = async (number, expiry, cvc, signal) => {
    const accountID = getActiveAccount().id;

    const body = {
        account_id: accountID,
        number,
        expiry,
        cvc,
    }
    return await httpPost(creditCardUrl, body, signal);
}

const updateCreditCard = async (id, {isPrimary}, signal) => {
    const creditCardUpdateUrl = `${creditCardUrl}/${id}`;

    const body = {
        primary: isPrimary,
    };

    return await httpPut(creditCardUpdateUrl, body, signal);
}

const oneTimePayment = async (amount, cardNumber, expiry, cvc, savedCard = false, signal) => {
    const oneTimePaymentUrl = `${creditCardUrl}/pay`;
    const accountID = getActiveAccount().id;
    const body = {
        'account_id': accountID,
        'cvc': cvc,
        'amount': amount,
        'card_on_file': savedCard,
    };

    if (expiry) body['expiry'] = expiry;
    if (cardNumber) body['number'] = cardNumber;

    return await httpPost(oneTimePaymentUrl, body, signal);
};

export {
    oneTimePayment,
    getCreditCards,
    storeCreditCard,
    updateCreditCard,
};
